import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RopeShovelService } from '../../rope-shovel.service';
import { AdditionalRecordOverviewModel } from '../../models/rope-shovel.model';

@Component({
  selector: 'additional-records',
  templateUrl: './additional-records.component.html',
  styleUrls: ['./additional-records.component.scss']
})
export class AdditionalRecordsComponent implements OnInit {
  @Input() side: string = "Left";
  @Input() inspectionId: number = 0;
  @Input() compartTypeId: number = 0;
  records: AdditionalRecordOverviewModel[] = [];
  loadingData: boolean = true;

  @Output()
  loadingChange = new EventEmitter<boolean>();
  @Input()
  get loading() {
    return this.loadingData;
  }

  set loading(val) {
    this.loadingData = val;
    this.loadingChange.emit(this.loadingData);
  }

  constructor(private _service: RopeShovelService) { }

  ngOnInit() {
    this.loading = true;
    this._service.getAdditionalRecordsForInspectionCompartType(this.inspectionId, this.compartTypeId, this.side).subscribe(r => {
      this.records = r;
      console.log("Additional Records___", this.records)
      this.loading = false;
    });
  }

}
